import apiRetur from '@/api/supplier/retur';
import apiOption from '@/api/supplier/option';

const defaultState = () => ({
	listRetur: [],
	detailRetur: {},
	returPagination: '',
	OptionReturforAccept: [],
	OptionStatusRetur: [],
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setRetur(state, data) {
		state.listRetur = data.data
		state.returPagination = data.pagination;
	},
	setDetailRetur(state, data) {
		state.detailRetur = data
	},
	setOptionStatusRetur(state, data) {
		state.OptionStatusRetur = data
	},
	setOptionReturforAccept(state, data) {
		state.OptionReturforAccept = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataRetur(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getRetur({ commit }, params) {
		return new Promise((resolve) => {
			apiRetur.getRetur(params).then(({ data: { data } }) => {
				commit('setRetur', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setRetur', { data: [], pagination: {} });
			});
		});
	},
	async getDetailRetur({ commit, dispatch }, params) {
		await apiRetur.detailRetur(params).then(({ data: { data } }) => {
			commit('setDetailRetur', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailRetur', {});
		});
	},
	getOptionReturforAccept({ commit }, params) {
		apiOption.getOptionReturforAccept(params).then(({ data: { data } }) => {
			commit('setOptionReturforAccept', data.results);
		}).catch(() => {
			commit('setOptionReturforAccept', []);
		});
	},
	getOptionStatusRetur({ commit }) {
		return new Promise((resolve) => {
			apiRetur.getOptionStatusRetur().then(({ data: { data } }) => {
				commit('setOptionStatusRetur', data.results);
				resolve()
			}).catch(() => {
				commit('setOptionStatusRetur', []);
			});
		});
	},
	async exportRetur({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiRetur.exportRetur(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data retur'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async approveRetur({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiRetur.approveRetur(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menyetujui retur'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async rejectRetur({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiRetur.rejectRetur(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menolak retur'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};